module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-CondensedItalic.41aa5dd.woff";